import { UrlComponentDataValue } from '@shared/data/entity/fields/UrlField';
import { i18n } from '@shared/util/i18n';
import { validateEmails } from '@shared/util/validate/email';
import { validateUrls } from '@shared/util/validate/url';

// this validator gets called for each block when saving a low-code form

interface Props {
  componentType: string;
  value: any;
}

interface Result {
  isValid: boolean;
  errorMessage: string | null;
}

export function noCodeValidate({ componentType, value }: Props): Result {
  let isValid = true;
  let errorMessage: string | null = null;

  switch (componentType) {
    case 'EMAIL':
      if (!validateEmails(value)) {
        isValid = false;
        errorMessage = i18n('workflowTemplate.component.error.email.invalid');
      }
      break;
    case 'URL':
      const urls = value?.map((item: UrlComponentDataValue) => item.url);
      if (!validateUrls(urls)) {
        isValid = false;
        errorMessage = i18n('workflowTemplate.component.error.url.invalid');
      }
      break;
    default:
      break;
  }
  return {
    isValid,
    errorMessage,
  };
}
